import { $t } from 'hooks/i18n';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CanView } from 'components/Can';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { ImageViewer } from 'components/ImageViewer';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useAuth from 'hooks/useAuth';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
import MasterDetailPages from './MasterDetailPages';
const UsersListPage = (props) => {
		const auth = useAuth();
	const app = useApp();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: $t('search'),
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, currentRecord, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, setCurrentRecord, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalPages, currentPage, limit, setPrevPage, setNextPage } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: $t('view'),
			command: (event) => { app.navigate(`/users/view/${data.userid}`) },
			icon: "pi pi-eye",
			visible: () => auth.canView('users/view')
		},
		{
			label: $t('edit'),
			command: (event) => { app.navigate(`/users/edit/${data.userid}`) },
			icon: "pi pi-pencil",
			visible: () => auth.canView('users/edit')
		},
		{
			label: $t('delete'),
			command: (event) => { deleteItem(data.userid) },
			icon: "pi pi-trash",
			visible: () => auth.canView('users/delete')
		}
	]
	.filter((item) => {
		if(item.visible){
			return item.visible()
		}
		return true;
	});
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	function UseridTemplate(data){
		if(data){
			return (
				<Link to={`/users/view/${data.userid}`}> { data.userid }</Link>
			);
		}
	}
	function EmailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.email}`}>{ data.email }</a>
			);
		}
	}
	function PhonenumberTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`tel:${data.phonenumber}`}>{ data.phonenumber }</a>
			);
		}
	}
	function ProfilephotoTemplate(data){
		if(data){
			return (
				<><ImageViewer imageSize="small" previewSize="" src={data.profilephoto} width="50px" height="50px" numDisplay={1} style={{maxWidth:'100%'}} /></>
			);
		}
	}
	function MasterDetailBtnTemplate(data){
		if(data){
			return (
				<><Button className="p-button-text" onClick={()=>setCurrentRecord(data)} icon="pi pi-caret-down" label="" /></>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div  className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">{$t('loading')}</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					{$t('noRecordFound')}
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title={$t('deleteSelected')}/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-users`;
			return (
				<div className="m-2">
					<ExportPageData  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel={$t('')} tooltip={$t('export')} buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
	return (
		<div className="flex-grow-1">
			<div className="flex  justify-content-center">
				<div  className="m-2">
					<Button disabled={pagination.currentPage <= 1} label="Previous" onClick={()=>pagination.setPrevPage()} icon="pi pi-arrow-left" />
				</div>
				<div className="m-2">
					<Button disabled={pagination.currentPage >= totalPages} label="Next" onClick={()=>pagination.setNextPage()} icon="pi pi-arrow-right" icon-pos="right" />
				</div>
			</div>
		</div>
	)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
	<CanView pagePath="users/delete">
		<MultiDelete />
	</CanView>
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="UsersListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title={$t('users')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/users/add`}>
                        <Button label={$t('addNewUser')} icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder={$t('search')} className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="grid ">
                                <div className="col">
                                    <div className="page-records">
                                        <DataTable 
                                            lazy={true} 
                                            loading={loading} 
                                            selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                            value={records} 
                                            dataKey="userid" 
                                            sortField={sortBy} 
                                            sortOrder={sortOrder} 
                                            onSort={onSort}
                                            className=" p-datatable-sm" 
                                            stripedRows={true}
                                            showGridlines={false} 
                                            rowHover={true} 
                                            responsiveLayout="stack" 
                                            emptyMessage={<EmptyRecordMessage />} 
                                            >
                                            {/*PageComponentStart*/}
                                            <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                            <Column headerStyle={{width: '3rem'}} field=""  body={MasterDetailBtnTemplate}  ></Column>
                                            <Column  field="userid" header={$t('userid')} body={UseridTemplate} sortable={true} ></Column>
                                            <Column  field="username" header={$t('username')}  sortable={true} ></Column>
                                            <Column  field="email" header={$t('email')} body={EmailTemplate} sortable={true} ></Column>
                                            <Column  field="user_role_id" header={$t('userRoleId')}  sortable={true} ></Column>
                                            <Column  field="phonenumber" header={$t('phonenumber')} body={PhonenumberTemplate} sortable={true} ></Column>
                                            <Column  field="customername" header={$t('customername')}  sortable={true} ></Column>
                                            <Column  field="address" header={$t('address')}  sortable={true} ></Column>
                                            <Column  field="createdat" header={$t('createdat')}  sortable={true} ></Column>
                                            <Column  field="profilephoto" header={$t('profilephoto')} body={ProfilephotoTemplate} sortable={true} ></Column>
                                            <Column  field="is_active" header={$t('isActive')}   ></Column>
                                            <Column  field="empcode" header={$t('empcode')}   ></Column>
                                            <Column  field="account_status" header={$t('accountStatus')}   ></Column>
                                            <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                            {/*PageComponentEnd*/}
                                        </DataTable>
                                    </div>
                                    <PageFooter />
                                </div>
                                {
                                (currentRecord && !props.isSubPage) && 
                                <div className="col-12">
                                    <div className="card p-0">
                                        <MasterDetailPages masterRecord={currentRecord} scrollIntoView={true} />
                                    </div>
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
UsersListPage.defaultProps = {
	primaryKey: 'userid',
	pageName: 'users',
	apiPath: 'users/index',
	routeName: 'userslist',
	msgBeforeDelete: $t('promptDeleteRecord'),
	msgTitle: $t('deleteRecord'),
	msgAfterDelete: $t('recordDeletedSuccessfully'),
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default UsersListPage;
